<div class="loading-container">
    <mat-spinner diameter="30" />
</div>
